import { ApiError } from '../core/api/types'

/** Traduz um erro da API numa mensagem amigável para toast. */
export function apiErrorMessage(err: unknown, fallback = 'Algo deu errado. Tente novamente.'): string {
  if (err instanceof ApiError) {
    switch (err.code) {
      case 'NETWORK_ERROR':
        return 'Sem conexão com o servidor. Tente novamente.'
      case 'FORBIDDEN':
        return 'Você não tem permissão para esta ação.'
      // O servidor manda a key na mensagem quando ajuda; aqui a frase genérica é
      // melhor, porque quem lê não administra permissão e não age sobre a key.
      case 'PERMISSION_DENIED':
        return 'Seu acesso não inclui esta ação. Fale com um administrador.'
      case 'ALREADY_EXISTS':
        return err.message || 'Já existe um registro com estes dados.'
      case 'VALIDATION_ERROR':
        return err.message || 'Verifique os campos e tente de novo.'
      case 'INVALID_STATE_TRANSITION':
        return err.message || 'Esta transição não é permitida.'
      default:
        return err.message || fallback
    }
  }
  return fallback
}
